import React, { useEffect } from "react";
import servicesData from "../components/utility/ServiceData";
import { ServiceCard } from "./BrainServices";
import { Helmet } from "../components/common/Helmet";

const SpineServices: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        //eslint-disable-next-line
    }, [])
    const serviceEnteries = Object.entries(servicesData).slice(8, 14);
    return (
        <>
            <Helmet>
                <title>Spine Surgery Services | Dr. Gangesh Gunjan | Sarvodaya Hospital</title>
                <meta name="description" content="Neurosurgical spine care in Noida & Greater Noida with 12+ years clinical experience. Evaluation and treatment for Spine Injuries, Degenerative Disc Disease, Tumors, and Minimally Invasive Surgeries." />
                <meta name="keywords" content="spine surgeon Noida, Dr. Gangesh Gunjan, spine surgery, degenerative disc disease, spinal trauma, neurosurgery, Sarvodaya Hospital" />
            </Helmet>
            <div className="bg-gradient-to-b from-gray-50 to-white">
                <div className="container mx-auto px-4 py-16 mt-28">
                    <div className="max-w-4xl mx-auto mb-16">
                        <h2 className="text-4xl font-bold mb-12 text-center text-blue-900">Spine Services</h2>

                        <div className="space-y-8 text-lg leading-relaxed">
                            <p className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-blue-800">
                                Surgical evaluation may be recommended for conditions such as spinal deformities, spinal tumors, acute trauma, or advanced degenerative disc disease when conservative therapies no longer offer adequate relief. Dr. Gangesh Gunjan provides comprehensive spinal consultations and surgical care in Noida and Greater Noida.
                            </p>

                            <p className="bg-white p-6 rounded-lg shadow-sm">
                                Patients often consider spinal consultation after persistent symptoms such as radiating pain, numbness, or motor weakness that do not resolve with physical therapy and non-operative medical management.
                            </p>

                            <p className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-blue-800">
                                Modern microsurgical and endoscopic techniques allow for targeted procedures with small incisions and muscle preservation, supporting planned rehabilitation. Request a consultation by completing the appointment form.
                            </p>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {serviceEnteries.map(([slug, service]) => (
                            <ServiceCard
                                key={slug}
                                title={service.title}
                                description={service.description}
                                slug={slug}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SpineServices;